import { sharedCriteriaFields, sharedFeesFields } from './shared';

export const tradeFinanceCriteria = [
  ...sharedCriteriaFields(),
  {
    columns: 12,
    fields: [
      {
        field: 'approxGrossMargin',
        columns: 6,
        max: 100,
        min: 0,
        label: '0%',
        rightElement: '100%',
        type: 'slider',
      },
    ],
    label: 'Gross margin minimum',
  },
  {
    columns: 6,
    fields: [
      {
        optionsColumns: 6,
        field: 'guarantees',
        type: 'multiple',
      },
    ],
    label: 'Required guarantees',
  },
  {
    columns: 6,
    fields: [
      {
        optionsColumns: 6,
        field: 'homeowner',
        type: 'boolean',
      },
    ],
    label: 'Do you require home ownership for personal guarantees?',
  },
  {
    columns: 12,
    fields: [
      {
        columns: 12,
        field: 'useOfFunds',
        optionsColumns: 4,
        type: 'multiple',
      },
    ],
    label: 'For what funding purposes is this product suitable?',
  },
];

export const tradeFinanceFees = sharedFeesFields(true);
